import React from "react";
import apiProxy from "../../api/apiProxy";
import OverridesPage from "./OverridesPage";

export default props => (
  <OverridesPage
    getCurrentOverrides={apiProxy.storeLighting.getCurrentOverrides}
  />
);
